import loadable from '@loadable/component';

export const ViewUnpublishedJobPageLoadable = loadable(
  () => import('./ViewUnpublishedJobPage'),
  { resolveComponent: (module) => module.ViewUnpublishedJobPage },
);
